export default __webpack_public_path__ + "images/15cdcd0c8708c79207d08791291f4f5d.svg";